<template>
	<div class="dep-con" style="display: flex;flex-direction: column;justify-content: center;align-items: flex-start;">
		<div style="display: flex;flex-direction: row;justify-content: space-between;width: 300px;" class="item_font">
			<div class="item_font" v-show="addDepartment">
				<el-dialog title="部门基础信息设置" :visible.sync="addDepartment" width="35%" center :close-on-click-modal="false" :close-on-press-escape="false" @close="closeAddDep">
					<div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
						<el-form :model="depForm" label-position="left" style="display: flex;flex-direction: column;justify-content: center;margin-left: 30px;margin-right: 30px;">
							<el-form-item label="部门名称:" :label-width="formLabelWidth" class="item_font">
								<el-input v-model="depForm.depName" style="width: 60%;margin-left: 6%;"></el-input>
							</el-form-item>
							<div style="color: #303133;font-size: 18px;margin: 15px auto;">部门属性规则设置</div>
							<el-form-item v-model="depForm.isExternal">
								<el-checkbox label="是否为外部部门" :disabled="externalDis" v-model="ExternalIsChecked"></el-checkbox>
								<span style="color: #999999;font-size: 14px;font: arial normal;margin-left: 10px;white-space: nowrap;">外部部门中的员工没有友好关系，不支持快捷回复库共享</span>
							</el-form-item>

							<!-- <el-form-item label="请设置优先级:" :label-width="formLabelWidth" style="margin-left: 5%;">
								<el-input v-model="depForm.priority" style="width: 65%;margin-left: -5px;" placeholder="请输入整数"></el-input>
								<span style="color: #999999;font-size: 14px;font: arial normal;margin-left: 10px;white-space: nowrap;">1~9999的整数</span>
							</el-form-item> -->
							<el-form-item v-model="depForm.automaticAllocation">
								<el-checkbox class="item_font"
									:disabled="automaticAllocationDis"
									label="永远不要对此部门人员进行自动分配"
									v-model="isAutomaticAllocation"
								></el-checkbox>
							</el-form-item>
						</el-form>
					</div>
					<div slot="footer" class="dialog-footer">
						<el-button @click="addDepartment = false" class="item_font">取 消</el-button>
						<el-button type="primary" @click="condirmAdd" class="item_font">确 定</el-button>
					</div>
				</el-dialog>
			</div>
		</div>
		<div style="margin-top: 30px;" class="item_font">
			<el-tree :data="depData" :indent="18" node-key="id" default-expand-all :expand-on-click-node="false">
				<span class="custom-tree-node" slot-scope="{ node, data }">
					<span :class="data.pid=='0'?'node_class1':'node_class2'">{{ node.label }}</span>
					<span>
						<el-button type="text" style="margin-left: 10px;" size="mini" @click="() => append(node,data)" class="item_font">新增</el-button>
						<el-button type="text" style="margin-left: 10px;" size="mini" @click="() => edit(node,data)" class="item_font">编辑</el-button>
						<el-button type="text" size="mini" @click="() => remove(node, data)" class="item_font">删除</el-button>
					</span>
				</span>
			</el-tree>
		</div>
	</div>
</template>

<script>
import {MessageBox} from 'element-ui';
export default {
	data() {
		return {
			name: '',
			addDepartment: false,
			ExternalIsChecked: false,
			isAutomaticAllocation:false,
			formLabelWidth: '120px',
			depForm: {
				id:'',
				depName: '',
				pid: '',
				isExternal: 0,
				priority: '7',
				automaticAllocation: 0,
				path:""
			},
			newTree:{},
			depData: [
				
			],
			action:"新增",
			automaticAllocationDis:false,
			externalDis:false
		};
	},
	mounted() {
		console.log('DepartmentList mounted function');
		this.depSelect()
	},
	methods: {
		handleOpen(key, keyPath) {
			console.log(key, keyPath);
		},
		handleClose(key, keyPath) {
			console.log(key, keyPath);
		},
		async condirmAdd() {
			var api = "/manager/dep/edit" 
			this.depForm.isExternal=this.ExternalIsChecked==true?1:0
			this.depForm.automaticAllocation=this.isAutomaticAllocation==true?0:1
			this.depForm.priority="7"
			console.log("新增部门数据",this.depForm)
			if(this.depForm.depName===""){
				this.$message.error("部门名字不能为空")
			}else{
				const response=await this.util.postRequest({
					url:api,
					method:"POST",
					data:this.depForm
				})
				if(response.resultCode==="10000"){
					this.addDepartment = false;
					this.$message.success("保存成功")
					this.depSelect()
					this.depForm={
						id:'',
						depName: '',
						pid: '',
						isExternal: 0,
						priority: '',
						automaticAllocation: 0,
						path:''
					}
				
				}else{
					this.$message.error(response.desc)
				}
			}
			
		},
		append(node,data) {
			this.selectByPId(data.id)
			console.log("当前部门信息",data)
			this.action="新增"
			this.addDepartment=true
			this.depForm.pid = data.id
			this.depForm.path = data.path
			this.ExternalIsChecked=data.isExternal==1?true:false
			this.isAutomaticAllocation=data.automaticAllocation==0?true:false
		},
		async edit(node,data){
			this.selectByPId(data.pid)
			this.action="编辑"
			this.addDepartment=true
			this.depForm.id=data.id
			this.depForm.pid=data.pid
			this.depForm.depName=data.depName
			this.depForm.isExternal=data.isExternal
			this.depForm.priority=data.priority
			this.depForm.isAutomaticAllocation=data.isAutomaticAllocation
			this.depForm.path = data.path
			this.ExternalIsChecked=data.isExternal==1?true:false
			this.isAutomaticAllocation=data.automaticAllocation==0?true:false
		},
		async remove(node, data) {
			const tipMsg = '<p class="item_font">是否确认删除</p>'
			MessageBox.alert(tipMsg, "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
				showCancelButton: true,
				dangerouslyUseHTMLString: true
			}).then(()=>{
				this.deleteDep(data)
			})
		},
		async deleteDep(data){
			if(data.depVoList==null){
				var api = "/manager/dep/del"
				const response=await this.util.postRequest({
					url:api,
					method:"POST",
					data:{
						id:data.id
					},
				})
				if(response.resultCode==="10000"){
					// console.log("删除部门成功")
					this.$message.success("删除部门成功")
				}else{
					this.$message.error(response.desc)
				}
			}else{
				const tipMsg = "该部门存在子部门，删除部门失败！"
				MessageBox.alert(tipMsg, "提示", {
					confirmButtonText: "确定",
					cancelButtonText: null,
					type: "warning",
					showCancelButton: false,
				})
			}
			this.depSelect()
		},
		
		

		getTree(data){
			data.children = data.depVoList;
			data.label = data.depName
			// data.pid = data.pid
			if(data.children!=null){
				for(var i = 0; i < data.children.length; i++) {
					this.getTree(data.children[i])
				}
			}
		},
		async depSelect(){
			var api = "/manager/dep/select"
			const response=await this.util.postRequest({
				url:api,
				method:"POST",
				data:{
					
				},
			})
			console.log(response.data)
			for(var i = 0; i < response.data.length; i++){
				this.getTree(response.data[i])
			}
			this.depData=response.data
				
			console.log("this.depData",this.depData)
			
		},
		async selectByPId(pid){
			var api = "/manager/dep/selectByPId"
			const response=await this.util.postRequest({
				url:api,
				method:"POST",
				data:{
					id:pid
				},
			})
			console.log(response.data)
			// console.log(response.data.automaticAllocation)
			// console.log(response.data.isExternal)
			if(response.data!=undefined){
				this.automaticAllocationDis = response.data.automaticAllocation==0?true:false
				this.externalDis = response.data.isExternal==1?true:false
			}else{
				this.automaticAllocationDis = false
				this.externalDis = false
			}
			
			// this.externalDis = response.data.ex
		},
		closeAddDep(){
			this.depForm={
				id:'',
				depName: '',
				pid: '',
				isExternal: 0,
				priority: '',
				automaticAllocation: 0,
				path:''
			}
		}
	}
};
</script>

<style>
	.node_class1{
		font-size: 18px;
		@include change_size($font_size_normal)
		/* font-weight: 550; */
	}
	.node_class2{
		font-size: 16px;
	}
</style>
